import { ReducerBuilder } from "./ReducerBuilder";
import * as AssessmentActions from "../actions/assessments";
import { Assessment } from "../interfaces/AssessmentInterfaces";
import { RootState } from "../store";

const INITIAL_STATE = {
  collection: { results: [], total: null },
  clientSpecific: [],
  symptoms: [],
  labTests: [],
  lastTouched: null,
  template: []
};

function setAssessments(state, payload) {
  return { ...state, collection: payload };
}

function setClientAssessments(state, payload) {
  return { ...state, clientSpecific: payload };
}

function setAssessment(state, payload) {
  if (!payload) return state;
  const list = state.clientSpecific.filter(({ id }) => payload.id !== id);
  list.push(payload);
  return { ...state, clientSpecific: list };
}

function putAssessment(state, payload) {
  const newState = setAssessment(state, payload);
  newState.lastTouched = payload;
  return newState;
}

function getSymptoms(state, payload) {
  return { ...state, symptoms: payload };
}

function getLabTests(state, payload) {
  return { ...state, labTests: payload };
}

function setAsessmentTemplate(state, payload) {
  return { ...state, template: Array.isArray(payload) ? payload : [] };
}

function addAssessmentTemplate(state: RootState, payload: Assessment) {
  const newTemplates = Array.isArray(state.template) ? [...state.template] : [];
  newTemplates.push(payload);
  return { ...state, template: newTemplates };
}

function updateAssessmentTemplate(state: RootState, payload: Assessment) {
  const templates = Array.isArray(state.template) ? state.template : [];
  const newTemplates = templates.map((template: Assessment) =>
    template.id === payload.id ? payload : template
  );
  return { ...state, template: newTemplates };
}

function deleteAssessmentTemplate(state: RootState, payload: number) {
  const templates = Array.isArray(state.template) ? state.template : [];
  const newTemplates = templates.filter((template: Assessment) => template.id !== payload);
  return { ...state, template: newTemplates };
}

const reducer = ReducerBuilder.create(INITIAL_STATE)
  .mapAction(AssessmentActions.Type.GET_ASSESSMENTS, setAssessments)
  .mapAction(AssessmentActions.Type.GET_ASSESSMENTS_BY_CLIENT, setClientAssessments)
  .mapAction(AssessmentActions.Type.GET_ASSESSMENT_BY_ID, setAssessment)
  .mapAction(AssessmentActions.Type.CREATE_ASSESSMENT, putAssessment)
  .mapAction(AssessmentActions.Type.UPDATE_ASSESSMENT, putAssessment)
  .mapAction(AssessmentActions.Type.GET_SYMPTOMS, getSymptoms)
  .mapAction(AssessmentActions.Type.GET_ASSESSMENT_BY_UUID, setAssessment)
  .mapAction(AssessmentActions.Type.GET_LABTEST, getLabTests)
  .mapAction(AssessmentActions.Type.GET_ASSESSMENT_TEMPLATE, setAsessmentTemplate)
  .mapAction(AssessmentActions.Type.CREATE_ASSESSMENT_TEMPLATE, addAssessmentTemplate)
  .mapAction(AssessmentActions.Type.UPDATE_ASSESSMENT_TEMPLATE, updateAssessmentTemplate)
  .mapAction(AssessmentActions.Type.DELETE_ASSESSMENT_TEMPLATE, deleteAssessmentTemplate)
  .build();

export default reducer;
